import React from 'react'
import {
  Box,
  useMediaQuery,
  useTheme,
  makeStyles,
  createStyles,
  Dialog,
  IconButton,
  DialogContent,
  Divider,
} from '@material-ui/core'
import { ReactComponent as ErrorOutlineIcon } from 'src/mobile/assets/icons/modal_icon.svg'
import { useTranslation } from 'react-i18next'
import { PACKAGE_INFO } from 'src/utils/constant'
import EDrawerColor from 'src/mobile/themes/components/EDrawerColor'
import ENumberFormat from 'src/mobile/themes/components/ENumberFormat'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) =>
  createStyles({
    icon: {
      flexShrink: 0,
      width: theme.spacing(3),
      height: theme.spacing(3),
      cursor: 'pointer',
      '& path': {
        width: theme.spacing(1.75),
        height: theme.spacing(1.75),
        fill: theme.palette.grey[800],
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
    dialogContent: {
      paddingBottom: theme.spacing(4),
    },
  }),
)
const DetailModal = ({ value, price, currency }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const classes = useStyles()

  const [modal, setModal] = React.useState(false)
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const program = [
    {
      title: t('productPage.cbc'),
      function: [
        { name: t('check_program.hb') },
        { name: t('check_program.hct') },
        { name: t('check_program.plt') },
        { name: t('check_program.wbc') },
        { name: t('check_program.rbc') },
        { name: t('check_program.mcv') },
        { name: t('check_program.mcn') },
        { name: t('check_program.mchc') },
        { name: t('check_program.wbcc') },
      ],
    },
    {
      title: t('productPage.liver_function'),
      function: [
        { name: t('check_program.total_bilo') },
        { name: t('check_program.direct_bili') },
        { name: t('check_program.ast') },
        { name: t('check_program.alt') },
        { name: t('check_program.ggt') },
        { name: t('check_program.alp') },
        { name: t('check_program.total_protein') },
        { name: t('check_program.albumin') },
        { name: t('check_program.globulin') },
      ],
    },
    {
      title: t('productPage.renal_function'),
      function: [
        { name: t('check_program.urea') },
        { name: t('check_program.creatinine') },
        { name: t('check_program.sodium') },
        { name: t('check_program.potass') },
        { name: t('check_program.chlor') },
        { name: t('check_program.bicarbonate') },
        { name: t('check_program.egfr') },
      ],
    },
    {
      title: t('productPage.diabetes_screening'),
      function: [{ name: t('check_program.fast_glucose') }],
    },
    {
      title: t('productPage.blood_lipids'),
      function: [
        { name: t('check_program.cholesterol') },
        { name: t('check_program.hdl') },
        { name: t('check_program.ldl') },
        { name: t('check_program.triglycerides') },
      ],
    },
    {
      title: t('productPage.thyroid_assessment'),
      function: [{ name: t('check_program.tsh') }, { name: t('check_program.T4') }],
    },
    {
      title: t('productPage.Cardiovascular Function Assessment'),
      function: [{ name: t('check_program.ecg') }],
    },
    {
      title: t('productPage.chest'),
      function: [{ name: t('check_program.x-ray') }],
    },
    {
      title: t('productPage.report_explain'),
      function: [{ name: t('check_program.register_expalin') }],
    },
  ]
  const ItemDot = () => (
    <Box color="grey.900" mr={1} component="span" fontWeight={800}>
      •
    </Box>
  )
  const renderContent = () => {
    return (
      <>
        {Number(value) === 1 && (
          <>
            <Box my={2} fontWeight={600} fontSize={16}>
              {t('glossary.prophecy')}
            </Box>
            <Box fontSize={16} lineHeight={1.5}>
              {t('glossary.npc.detail_modal')}
            </Box>
            <Box fontWeight={600} fontSize={16} my={2}>
              {t('productPage.NPC_anchor3')}:
            </Box>
            <Box fontSize={16} lineHeight={1.5}>
              <Box>•{t('glossary.npc_modal.0')}</Box>
              <Box>•{t('glossary.npc_modal.1')}</Box>
              <Box>•{t('productPage.NPC.special.3')}</Box>
              <Box>•{t('glossary.npc_modal.3')}</Box>
              <Box>•{t('productPage.NPC.special.5')}</Box>
              <Box>•{t('productPage.NPC.special.6')}</Box>
            </Box>
          </>
        )}
        {Number(value) === 2 && (
          <>
            <Box my={2} fontWeight={600} fontSize={16}>
              {t('form.cancer')}
            </Box>

            <Box fontWeight={600} fontSize={16} my={2}>
              {t('glossary.cancer_modal.0')}:
            </Box>
            <Box fontSize={16} lineHeight={1.5}>
              <Box>– {t('glossary.prophecy')}</Box>
              <Box>– {t('glossary.cancer_modal.list.1')}</Box>
              <Box>– {t('glossary.cancer_modal.list.2')}</Box>
              <Box>– {t('glossary.cancer_modal.list.3')}</Box>
              <Box>
                – {t('glossary.cancer_modal.list.4')}– {t('glossary.cancer_modal.list.7')}
              </Box>
              <Box>
                – {t('glossary.cancer_modal.list.5')}– {t('glossary.cancer_modal.list.7')}
              </Box>
              <Box>
                – {t('glossary.cancer_modal.list.6')}– {t('glossary.cancer_modal.list.8')}
              </Box>
              <Box color="grey.500" fontSize={12}>
                {t('productPage.attention')}
              </Box>
            </Box>
          </>
        )}
        {(Number(value) === 3 || Number(value) === 4 || Number(value) === 5) && (
          <>
            <Box my={2} fontSize={14}>
              {t('productPage.all_program')}
            </Box>
            <Box>
              <Box
                fontSize={16}
                fontWeight={600}
                bgcolor="#F9FAFB"
                height={40}
                display="flex"
                alignItems="center"
                pl={2}
              >
                {t('productPage.cancer_check')}
              </Box>
              <Box
                fontSize={16}
                fontWeight={600}
                display="flex"
                pl={2}
                py={1}
                borderBottom="1px solid #E5E7EB"
              >
                <Box fontSize={14} fontWeight={400} textAlign="left" display="flex">
                  <ItemDot /> {t('glossary.prophecy')}
                </Box>
              </Box>
              {Number(value) === 4 && (
                <Box
                  fontSize={16}
                  fontWeight={600}
                  display="flex"
                  pl={2}
                  py={1}
                  borderBottom="1px solid #E5E7EB"
                >
                  <Box fontSize={14} fontWeight={400} textAlign="left" display="flex">
                    <ItemDot /> {t('check_program.psa')}
                  </Box>
                </Box>
              )}
              {Number(value) === 5 && (
                <Box
                  fontSize={16}
                  fontWeight={600}
                  display="flex"
                  pl={2}
                  py={1}
                  borderBottom="1px solid #E5E7EB"
                >
                  <Box fontSize={14} fontWeight={400} textAlign="left" display="flex">
                    <ItemDot /> {t('check_program.pap')}{' '}
                  </Box>
                </Box>
              )}
              {program?.map((item, index) => (
                <Box key={index}>
                  <Box
                    fontSize={16}
                    fontWeight={600}
                    bgcolor="#F9FAFB"
                    height={40}
                    display="flex"
                    alignItems="center"
                    pl={2}
                  >
                    {item.title}
                  </Box>
                  {item.function?.map((x, index2) => (
                    <Box
                      fontSize={16}
                      fontWeight={600}
                      display="flex"
                      pl={2}
                      py={1}
                      key={index2}
                      borderBottom="1px solid #E5E7EB"
                    >
                      <Box fontSize={14} fontWeight={400} textAlign="left" lineHeight={1.5} display="flex">
                        <ItemDot /> {x.name}
                      </Box>
                    </Box>
                  ))}
                </Box>
              ))}
            </Box>
          </>
        )}
      </>
    )
  }
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      py={isMobile ? 1.5 : 3.25}
      px={isMobile ? 0 : 10}
      borderBottom="1px solid #E5E7EB"
    >
      <Box fontWeight="fontWeightBold" color="grey.900" component="span" display="flex" alignItems="center">
        <ErrorOutlineIcon className={classes.icon} fontSize="medium" onClick={() => setModal(true)} />
        <Box
          style={{ whiteSpace: 'break-spaces' }}
          maxWidth={isMobile ? 150 : 600}
          onClick={() => setModal(true)}
        >
          {t(PACKAGE_INFO[value]?.title)}
        </Box>
        {isMobile && Number(value) === 1 && (
          <EDrawerColor open={modal} onClose={() => setModal(false)} title={t('form.program_detail')}>
            {renderContent(value)}
          </EDrawerColor>
        )}
        {isMobile && Number(value) === 2 && (
          <EDrawerColor open={modal} onClose={() => setModal(false)} title={t('form.program_detail')}>
            {renderContent(value)}
          </EDrawerColor>
        )}
        {(Number(value) === 3 || Number(value) === 4 || Number(value) === 5) && isMobile && (
          <EDrawerColor open={modal} onClose={() => setModal(false)} title={t('form.program_detail')}>
            {renderContent(value)}
          </EDrawerColor>
        )}
      </Box>
      <Box color="secondary.main">
        {/* <Box component="span">{t('glossary.service_charge')}: </Box> */}
        <ENumberFormat
          color="secondary.main"
          value={price}
          currency={currency}
          isModal
          fontSize={isMobile ? 16 : 20}
        />
      </Box>
      <Dialog maxWidth="xs" open={!isMobile && modal} fullWidth onClose={() => setModal(false)}>
        <Box mb={2}>
          <Box py={2} fontSize={20} fontWeight={600} textAlign="center">
            {t('form.program_detail')}
          </Box>
          <IconButton
            className={classes.closeButton}
            aria-label="close"
            onClick={() => {
              setModal(false)
            }}
            color="primary"
          >
            <CloseIcon />
          </IconButton>
          <Divider />
        </Box>
        <DialogContent className={classes.dialogContent}>{renderContent(value)}</DialogContent>
      </Dialog>
    </Box>
  )
}

export default DetailModal
